import React, { FC } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import ctaTypes from '../../../enums/CTA.enums';
import useEEActive from '../../../hooks/useEEActive';
import { TLinkField } from '../../../types/sitecore.types';
import { checkIsHrefValid } from '../../../utils/checkIsHrefValid.utils';
import '../CTA/styles.scss';
import Icon from '../icon';
import RoutableSitecoreLink from '../routableSitecoreLink';
import './styles.scss';

type DownloadCTAProps = WithTranslation & {
  type?: ctaTypes;
  field: TLinkField;
  extraClassName?: string;
};

const DownloadCTA: FC<DownloadCTAProps> = ({ type = ctaTypes['primaryWhite'], field, extraClassName = '', t }) => {
  const isEE = useEEActive();
  const isHrefValid = checkIsHrefValid(field?.value?.href);

  if (!isHrefValid && !isEE) {
    return null;
  }

  const ctaClassName = ['button', type, extraClassName].join(' ');
  const downloadLinkText = (
    <>
      {t('cnhi-downloadCTA')}
      <Icon iconName={'action-download'} size={24} color={'primary'} extraClassName={'download-cta__icon'} />
    </>
  );

  return (
    <RoutableSitecoreLink
      field={{ ...field, value: { ...field?.value, text: downloadLinkText } }}
      className={`${ctaClassName} download-cta ${extraClassName}`}
      target={'_blank'}
    />
  );
};

export default withTranslation()(React.memo(DownloadCTA));
